import { ActionBeginEventArgs } from '@fluentsms/syncfusion';

/**
 * This function takes in two parameters, and if the Syncfusion event that is beginning is an Undo event, hijack the
 * event and provide custom behavior to the undo event
 * @param { ActionBeginEventArgs | undefined} args the ActionBeginEventArgs from Syncfusion
 * @param {(text: string) => string} wrapMergeFields a function that wraps the merge fields in non-editable spans for the mini-editor
 * @param {string} textContent The current text content of the mini-editor
 * @returns {string} the new textContent of the mini-editor
 */
export function handleUndoAction(
  args: ActionBeginEventArgs | undefined,
  textContent: string,
  wrapMergeFields?: (text: string) => string,
): string {
  if (args && wrapMergeFields) {
    const { name } = args;
    if (name === 'undo' || name === 'Undo') {
      return wrapMergeFields(textContent);
    }
  }
  return textContent;
}
